import React from 'react';
import '../../scss/MaterialRequestScanner.scss';
import { MaterialRequestScannerApp } from './Functionality/MaterialRequestScannerApp';
import ScannerCard from './Subcomponents/ScannerCard';
import ScannerStatusCard from './Subcomponents/ScannerStatusCard';
import ManualFolioModal from './Subcomponents/ManualFolioModal';
import FullPageLoader from '../../utils/FullPageLoader';
import HeadTittle from '../../components/HeadTittle';

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
const MaterialRequestScanner = () => {
    const {
        t,
        status,
        currentAction,
        showSpinner,
        showManualFolio,
        selectedFolio,
        setSelectedFolio,
        handleOpenManualFolio,
        handleCloseManualFolio,
        handleOpenRequest,
        goBack,
    } = MaterialRequestScannerApp();

    return (
        <>
            {showSpinner && <FullPageLoader />}
            <div className='scanner-background'>
                <div className='scanner-header'>
                    <HeadTittle name={'qr_scanner'} onBack={goBack}>
                        <ScannerStatusCard t={t} currentAction={currentAction} />
                    </HeadTittle>
                </div>

                <div className='scanner-content'>
                    <ScannerCard
                        t={t}
                        status={status}
                        onEnterFolioManually={handleOpenManualFolio}
                    />
                </div>
            </div>

            {showManualFolio &&
                <ManualFolioModal
                    t={t}
                    show={showManualFolio}
                    selectedFolio={selectedFolio}
                    setSelectedFolio={setSelectedFolio}
                    onHide={handleCloseManualFolio}
                    onConfirm={handleOpenRequest}
                />
            }
        </>
    );
};

export default MaterialRequestScanner;
